namespace RioERP.Web.Enums {
    export enum EAdjustmentType {
        SetValue = 1,
        FullDiscount = 2,
        FullConsider = 3
    }
    Serenity.Decorators.registerEnumType(EAdjustmentType, 'RioERP.Web.Enums.EAdjustmentType');
}
